import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="w-full px-4 pt-10 pb-12 max-w-3xl mx-auto" data-id="element-107">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="text-center space-y-6" data-id="element-108">
        <h2 className="font-handwriting text-4xl md:text-5xl lg:text-6xl text-forest font-bold leading-tight" data-id="element-109">
          "Nach der Antibiotika-Kur war Ben nicht mehr er selbst – bis ich das
          entdeckte"
        </h2>

        <p className="font-serif text-lg md:text-xl text-brown/90 max-w-2xl mx-auto leading-relaxed" data-id="element-110">
          Wie ich Bens Darmflora auf natürlichem Weg wieder aufgebaut habe.
        </p>

        <div className="relative mt-8 rounded-2xl overflow-hidden shadow-paper border-4 border-white rotate-1" data-id="element-111">
          <img src="https://images.unsplash.com/photo-1567752881298-894bb81f9379?auto=format&fit=crop&q=80&w=1000" alt="Ben, ein hübscher Rottweiler" className="w-full h-auto object-cover aspect-[4/3] md:aspect-[16/9]" data-id="element-112" />
          <div className="absolute inset-0 bg-gradient-to-t from-brown/20 to-transparent mix-blend-multiply" data-id="element-113"></div>
        </div>
      </motion.div>
    </section>;
}